export const detectSurvivalStep = (override = {}) => ({
  prompt: 'Detecting survival column...',
  llmDetect: true,
  plotImg: false,
  qa_bot: false,
  llmEndpoint: '/api/llm_detect_survival',
  llmLabel: 'survival_col',
  fallbackNext: 'surv_manual_select',
  ...override  
});

export const detectDurationStep = (override = {}) => ({
  prompt: 'Detecting time column...',
  llmDetect: true,
  plotImg: false,
  qa_bot: false,
  llmEndpoint: '/api/llm_detect_duration',
  llmLabel: 'duration_col',
  fallbackNext: 'duration_manual_select',
  ...override  
});

export const detectFactorStep = (override = {}) => ({
  prompt: 'Detecting factor columns...',
  llmDetect: true,
  plotImg: false,
  qa_bot: false,
  llmEndpoint: '/api/llm_detect_factor',
  llmLabel: 'factor_col',
  fallbackNext: 'factor_manual_select',
  ...override  
});

export const detectIdentityStep = (override = {}) => ({
  prompt: 'Detecting ID column...',
  llmDetect: true,
  plotImg: false,
  qa_bot: false,
  llmEndpoint: '/api/llm_detect_id',
  llmLabel: 'id_col',
  fallbackNext: 'id_manual_select',
  ...override  
});

export const detectFixFactorStep = (override = {}) => ({
  prompt: 'Detecting main factor column...',
  llmDetect: true,
  plotImg: false,
  qa_bot: false,
  llmEndpoint: '/api/llm_detect_mainfactor',
  llmLabel: 'mainfactor_col',
  fallbackNext: 'fixfactor_manual_select',
  ...override  
});

export const detectCatFactorStep = (override = {}) => ({
  prompt: 'Detecting categorical factor columns...',
  llmDetect: true,
  plotImg: false,
  qa_bot: false,
  llmEndpoint: '/api/llm_detect_factor',
  llmLabel: 'factor_col',
  fallbackNext: 'catfactor_manual_select',
  ...override  
});

export const detectNumFactorStep = (override = {}) => ({
  prompt: 'Detecting numerical factor columns...',
  llmDetect: true,
  plotImg: false,
  qa_bot: false,
  llmEndpoint: '/api/llm_detect_factor',
  llmLabel: 'factor_col_num',
  fallbackNext: 'numfactor_manual_select',
  ...override  
});

export const detectDurationFeatStep = (override = {}) => ({
  prompt: 'Detecting time column...',
  llmDetect: true,
  plotImg: false,
  qa_bot: false,
  llmEndpoint: '/api/llm_detect_duration_feat',
  llmLabel: 'duration_col',
  fallbackNext: 'duration_manual_feat_select',
  ...override  
});

export const detectSurvivalFeatStep = (override = {}) => ({
  prompt: 'Detecting survival columns...',
  llmDetect: true,
  plotImg: false,
  qa_bot: false,
  llmEndpoint: '/api/llm_detect_survival_feat',
  llmLabel: 'survival_col',
  fallbackNext: 'survival_manual_feat_select',
  ...override  
});

export const detectIdentityFeatStep = (override = {}) => ({
  prompt: 'Detecting ID column...',
  llmDetect: true,
  plotImg: false,
  qa_bot: false,
  llmEndpoint: '/api/llm_detect_id_feat',
  llmLabel: 'id_col',
  fallbackNext: 'id_manual_feat_select',
  ...override  
});

export const qa_bot = (override = {}) => ({
  prompt:"The preliminary analysis has been completed. You may now ask questions about the results.",
  qa_bot: true,
  llmDetect: false,
  plotImg: false,
  EndPoint:"",
  ...override
})

export const plot_kmf = (override = {}) => ({
  prompt: 'Generating figure...',
  llmDetect: false,
  plotImg: true,
  qa_bot: false,
  llmEndpoint: '/api/get_kmf',
  llmLabel: 'plot_kmf',
  fallbackNext: 'plot_kmf_fallback',
  ...override  
});

export const plot_cox = (override = {}) => ({
  prompt: 'Generating figure...',
  llmDetect: false,
  plotImg: true,
  qa_bot: false,
  llmEndpoint: '/api/get_cox',
  llmLabel: 'plot_cox',
  fallbackNext: 'plot_cox_fallback',
  ...override  
});

export const plot_bar = (override = {}) => ({
  prompt: 'Generating figure...',
  llmDetect: false,
  plotImg: true,
  qa_bot: false,
  llmEndpoint: '/api/get_bar',
  llmLabel: 'plot_bar',
  fallbackNext: 'plot_bar_fallback',
  ...override  
});

export const plot_box = (override = {}) => ({
  prompt: 'Generating figure...',
  llmDetect: false,
  plotImg: true,
  qa_bot: false,
  llmEndpoint: '/api/get_box',
  llmLabel: 'plot_box',
  fallbackNext: 'plot_box_fallback',
  ...override  
});

export const plot_pie = (override = {}) => ({
  prompt: 'Generating figure...',
  llmDetect: false,
  plotImg: true,
  qa_bot: false,
  llmEndpoint: '/api/get_pie',
  llmLabel: 'plot_pie',
  fallbackNext: 'plot_pie_fallback',
  ...override  
});

export const plot_scatter = (override = {}) => ({
  prompt: 'Generating figure...',
  llmDetect: false,
  plotImg: true,
  qa_bot: false,
  llmEndpoint: '/api/get_scatter',
  llmLabel: 'plot_scatter',
  fallbackNext: 'plot_scatter_fallback',
  ...override  
});

export const plot_heatmap = (override = {}) => ({
  prompt: 'Generating figure...',
  llmDetect: false,
  plotImg: true,
  qa_bot: false,
  llmEndpoint: '/api/get_heatmap',
  llmLabel: 'plot_heatmap',
  fallbackNext: 'plot_pie_heatmap',
  ...override  
});

export const plot_lme_single = (override = {}) => ({
  prompt: 'Generating figure...',
  llmDetect: false,
  plotImg: true,
  qa_bot: false,
  llmEndpoint: '/api/get_lme_single',
  llmLabel: 'plot_lme_single',
  fallbackNext: 'plot_lme_single_fallback',
  ...override  
});

export const plot_lme_multi = (override = {}) => ({
  prompt: 'Generating figure...',
  llmDetect: false,
  plotImg: true,
  qa_bot: false,
  llmEndpoint: '/api/get_lme_multi',
  llmLabel: 'plot_lme_multi',
  fallbackNext: 'plot_lme_multi_fallback',
  ...override  
});

export const plot_main_correlation = (override = {}) => ({
  prompt: 'Generating pearson correlation map',
  llmDetect: false,
  plotImg: true,
  qa_bot: false,
  llmEndpoint: '/api/get_corr',
  fallbackNext: '',
  ...override
});

export const pick_corr_pair = (override = {}) => ({
  prompt: 'General pearson correlation finished. You can now pick variables for detail correlation tests.',
  llmDetect: false,
  plotImg: false,
  qa_bot: false,
  pickCol: true,
  multi: true,                 
  pickFor: 'corr_pair',
  llmLabel: 'corr_pair',     
  ...override
});

export const plot_detail_correlation = (override = {}) => ({
  prompt: '',
  llmDetect: false,
  plotImg: true,
  qa_bot: false,
  llmEndpoint: '/api/get_corr_detail',
  fallbackNext: '',
  ...override
});

export const suggest_grouping_step = (override = {}) => ({
  prompt: 'Here we grouped columns based on names. You can adjust or confirm.',
  llmDetect: false,
  plotImg: false,
  qa_bot: false,
  groupEdit: true,
  llmEndpoint: '/api/get_col_groups',
  groupingLabel: 'grouping', 
  ...override
});

export const plot_mlr = (override = {}) => ({
  prompt: '',
  llmDetect: false,
  plotImg: true,
  qa_bot: false,
  llmEndpoint: '/api/get_mlr',
  fallbackNext: '',
  ...override
});

export const run_risk_predict_kmean = (override = {}) => ({
  prompt:'Start risk predicting...',
  llmDetect: false,
  plotImg: true,
  qa_bot: false,
  llmEndpoint: '/api/get_risk_pred',
  fallbackNext: '',
  feat: true,
  ...override
});
export const run_risk_predict_gmm = (override = {}) => ({
  prompt:'Start risk predicting...',
  llmDetect: false,
  plotImg: true,
  qa_bot: false,
  llmEndpoint: '/api/get_risk_pred_gmm',
  fallbackNext: '',
  feat: true,
  ...override
});

export const run_risk_predict_hier = (override = {}) => ({
  prompt:'Start risk predicting...',
  llmDetect: false,
  plotImg: true,
  qa_bot: false,
  llmEndpoint: '/api/get_risk_pred_hier',
  fallbackNext: '',
  feat: true,
  ...override
});

export const run_risk_predict_spectral = (override = {}) => ({
  prompt:'Start risk predicting...',
  llmDetect: false,
  plotImg: true,
  qa_bot: false,
  llmEndpoint: '/api/get_risk_pred_spectral',
  fallbackNext: '',
  feat: true,
  ...override
});

export const concat_feature = (override = {}) => ({
  prompt: 'Start feature fusion...',
  llmDetect: false,
  plotImg: false,
  qa_bot: false,
  featureFusion: true,
  llmEndpoint: '/api/concat',
  fallbackNext: 'send_finish_msg',
  ...override
});

export const mean_feature = (override = {}) => ({
  prompt: 'Start feature fusion...',
  llmDetect: false,
  plotImg: false,
  qa_bot: false,
  featureFusion: true,
  llmEndpoint: '/api/mean_fusion',
  fallbackNext: 'send_finish_msg',
  ...override
});

export const max_feature = (override = {}) => ({
  prompt: 'Start feature fusion...',
  llmDetect: false,
  plotImg: false,
  qa_bot: false,
  featureFusion: true,
  llmEndpoint: '/api/max_fusion',
  fallbackNext: 'send_finish_msg',
  ...override
});

export const normalized_feature = (override = {}) => ({
  prompt: 'Start feature fusion...',
  llmDetect: false,
  plotImg: false,
  qa_bot: false,
  featureFusion: true,
  llmEndpoint: '/api/normalized_fusion',
  fallbackNext: 'send_finish_msg',
  ...override
});

export const presetTree = {
  root:{
    prompt:"Hi, which analysis method do you want to do today?",
    options:[
      // { id: 'linearmix', label: 'Conduct a linear mixed model (LMM) analysis.', next: 'linearmix_methods' },
      { id: 'survival', label: 'Conduct a survival rate analysis.', next: 'survival_methods' },
      { id: 'distribution', label: 'Conduct statistical analysis of the features.', next: 'distribution_methods' },
      { id : 'correlation', label: 'Conduct a correlation analysis', next: 'correlation_methods'},
      {id: 'risk', label: 'Conduct a risk prediction', next: 'feature_fusion_methods'}
    ]
  },
  linearmix_methods: {
    prompt: 'For linear mixed-effects analysis, would you like to perform a single-variable time trend analysis or a multifactor interaction analysis?',
    options: [
      {id: 'single_lme', 
      label:'single-variable LME', 
      steps:[
        detectDurationStep(),
        detectFactorStep(),
        detectIdentityStep(),
        plot_lme_single(),
        qa_bot()
      ]},
      {id: 'multi_lme', 
      label:'Multivariative LME', 
      steps:[
        detectDurationStep(),
        detectFactorStep(),
        detectIdentityStep(),
        detectFixFactorStep(),
        plot_lme_multi(),
        qa_bot()
      ]}
    ]
  },
  survival_methods: {
    prompt: 'For survival analysis, the following methods are available. Which one would you like to use?',
    options:[
      {id:'kmf', 
      label:'Kaplan-Meier survival analysis', 
      steps:[
        detectSurvivalStep(),
        detectDurationStep(),
        detectFactorStep(),
        plot_kmf(),
        qa_bot(),
      ]},
      {id:'cox', 
      label:'Cox-PH survival analysis', 
      steps:[
        detectSurvivalStep(),
        detectDurationStep(),
        detectFactorStep(),
        plot_cox(),
        qa_bot(),
      ]}
    ]
  },
  distribution_methods:{
    prompt: 'Which type of chart would you like to use for visualization?',
    options: [
      {id:'bar', 
      label:'Bar chart (Categorical / Numerical)', 
      steps:[
        detectIdentityStep(),
        detectFactorStep(),
        plot_bar(),
        qa_bot(),
      ]},
      {id:'pie', 
      label:'Pie chart (Categorical)', 
      steps:[
        detectCatFactorStep(),
        plot_pie(),
        qa_bot(),
      ]},
      {id:'box', 
      label:'Boxplot (Categorical x Numerical)', 
      steps:[
        detectCatFactorStep(),
        detectNumFactorStep(),
        plot_box(),
        qa_bot(),
      ]},
      {id:'scatter', 
      label:'Scatter plot (Numerical x Numerical)', 
      steps:[
        detectNumFactorStep(),
        plot_scatter(),
        qa_bot(),
      ]},
      {id:'heatmap', 
      label:'Heatmap plot (Categorical x Categorical)', 
      steps:[
        detectCatFactorStep(),
        plot_heatmap(),
        qa_bot(),
      ]}
    ]
  },
  correlation_methods: {
    options:[
        {id: 'pearson',
          label:'Start pearson correlation',
          steps:[
          plot_main_correlation(),
          pick_corr_pair(),
          plot_detail_correlation(),
          qa_bot()
        ]
      },
      {
        id: 'multi-linear-regression',
        label: 'Start multi linear regression',
        steps:[
          detectFixFactorStep(),
          suggest_grouping_step(),
          plot_mlr(),
          qa_bot()
        ]
      }
    ]
  },
  feature_fusion_methods: {
    prompt: 'Please choose a feature fusion method:',
    options:[
      {id: 'concat_fusion', label: 'concatenate', next: 'concat_feature_cluster_methods'},
      {id: 'max_fusion', label: 'max pooling', next: 'max_feature_cluster_methods'},
      {id: 'mean_fusion', label: 'mean pooling', next: 'mean_feature_cluster_methods'},
      {id: 'normalized_fusion', label: 'normalized', next: 'normalized_feature_cluster_methods'},
    ]
  },
  concat_feature_cluster_methods: {
    prompt: 'Please choose a cluster method:',
    options:[
      {
        id: 'Kmeans',
        label: 'Kmeans',
        steps:[
          detectDurationFeatStep(),
          detectIdentityFeatStep(),
          detectSurvivalFeatStep(),
          concat_feature(),
          run_risk_predict_kmean(),
          qa_bot()
        ]
      },
      {
        id: 'gmm',
        label: 'Gaussian Mixture Model',
        steps:[
          detectDurationFeatStep(),
          detectIdentityFeatStep(),
          detectSurvivalFeatStep(),
          concat_feature(),
          run_risk_predict_gmm(),
          qa_bot()
        ]
      },
      {
        id: 'spectral',
        label: 'Spectral clustering',
        steps:[
          detectDurationFeatStep(),
          detectIdentityFeatStep(),
          detectSurvivalFeatStep(),
          concat_feature(),
          run_risk_predict_spectral(),
          qa_bot()
        ]
      },
      {
        id: 'hier',
        label: 'Hierarchical clustering',
        steps:[
          detectDurationFeatStep(),
          detectIdentityFeatStep(),
          detectSurvivalFeatStep(),
          concat_feature(),
          run_risk_predict_hier(),
          qa_bot()
        ]
      }
    ]
  },
  mean_feature_cluster_methods: {
    prompt: 'Please choose a cluster method:',
    options:[
      {
        id: 'Kmeans',
        label: 'Kmeans',
        steps:[
          detectDurationFeatStep(),
          detectIdentityFeatStep(),
          detectSurvivalFeatStep(),
          mean_feature(),
          run_risk_predict_kmean(),
          qa_bot()
        ]
      },
      {
        id: 'gmm',
        label: 'Gaussian Mixture Model',
        steps:[
          detectDurationFeatStep(),
          detectIdentityFeatStep(),
          detectSurvivalFeatStep(),
          mean_feature(),
          run_risk_predict_gmm(),
          qa_bot()
        ]
      },
      {
        id: 'spectral',
        label: 'Spectral clustering',
        steps:[
          detectDurationFeatStep(),
          detectIdentityFeatStep(),
          detectSurvivalFeatStep(),
          mean_feature(),
          run_risk_predict_spectral(),
          qa_bot()
        ]
      },
      {
        id: 'hier',
        label: 'Hierarchical clustering',
        steps:[
          detectDurationFeatStep(),
          detectIdentityFeatStep(),
          detectSurvivalFeatStep(),
          mean_feature(),
          run_risk_predict_hier(),
          qa_bot()
        ]
      }
    ]
  },
  max_feature_cluster_methods: {
    prompt: 'Please choose a cluster method:',
    options:[
      {
        id: 'Kmeans',
        label: 'Kmeans',
        steps:[
          detectDurationFeatStep(),
          detectIdentityFeatStep(),
          detectSurvivalFeatStep(),
          max_feature(),
          run_risk_predict_kmean(),
          qa_bot()
        ]
      },
      {
        id: 'gmm',
        label: 'Gaussian Mixture Model',
        steps:[
          detectDurationFeatStep(),
          detectIdentityFeatStep(),
          detectSurvivalFeatStep(),
          max_feature(),
          run_risk_predict_gmm(),
          qa_bot()
        ]
      },
      {
        id: 'spectral',
        label: 'Spectral clustering',
        steps:[
          detectDurationFeatStep(),
          detectIdentityFeatStep(),
          detectSurvivalFeatStep(),
          max_feature(),
          run_risk_predict_spectral(),
          qa_bot()
        ]
      },
      {
        id: 'hier',
        label: 'Hierarchical clustering',
        steps:[
          detectDurationFeatStep(),
          detectIdentityFeatStep(),
          detectSurvivalFeatStep(),
          max_feature(),
          run_risk_predict_hier(),
          qa_bot()
        ]
      },
      
    ]
  },
  normalized_feature_cluster_methods: {
    prompt: 'Please choose a cluster method:',
    options:[
      {
        id: 'Kmeans',
        label: 'Kmeans',
        steps:[
          detectDurationFeatStep(),
          detectIdentityFeatStep(),
          detectSurvivalFeatStep(),
          normalized_feature(),
          run_risk_predict_kmean(),
          qa_bot()
        ]
      },
      {
        id: 'gmm',
        label: 'Gaussian Mixture Model',
        steps:[
          detectDurationFeatStep(),
          detectIdentityFeatStep(),
          detectSurvivalFeatStep(),
          normalized_feature(),
          run_risk_predict_gmm(),
          qa_bot()
        ]
      },
      {
        id: 'spectral',
        label: 'Spectral clustering',
        steps:[
          detectDurationFeatStep(),
          detectIdentityFeatStep(),
          detectSurvivalFeatStep(),
          normalized_feature(),
          run_risk_predict_spectral(),
          qa_bot()
        ]
      },
      {
        id: 'hier',
        label: 'Hierarchical clustering',
        steps:[
          detectDurationFeatStep(),
          detectIdentityFeatStep(),
          detectSurvivalFeatStep(),
          normalized_feature(),
          run_risk_predict_hier(),
          qa_bot()
        ]
      }
    ]
  },
  surv_manual_select: {
    prompt:"Please manually select the survival status column (single choice):",
    type: "manual_select",
    multi: false,
    presetKey:"surv_manual_select"
  },
  duration_manual_select: {
    prompt:"Please manually select the time column(s) (multiple choice):",
    type: "manual_select",
    multi: true,
    presetKey:"duration_manual_select",
  },
  factor_manual_select: {
    prompt:"Please manually select the factor column(s) (multiple choice):",
    type: "manual_select",
    multi: true,
    presetKey:"factor_manual_select",
  },
  fixfactor_manual_select: {
    prompt:"Please manually select the mainfactor column:",
    type: "manual_select",
    multi: false,
    presetKey:"fixfactor_manual_select",
  },
  catfactor_manual_select: {
    prompt:"Please manually select the categorical factor column(s) (multiple choice). If no columns are shown, please make sure there are categorical columns in your data.",
    type: "manual_select",
    multi: true,
    presetKey:"catfactor_manual_select",
  },
  numfactor_manual_select: {
    prompt:"Please manually select the numerical factor column(s) (multiple choice). If no columns are shown, please make sure there are numerical columns in your data.",
    type: "manual_select",
    multi: true,
    presetKey:"numfactor_manual_select",
  },
  id_manual_select: {
    prompt:"Please manually select the ID column (single choice):",
    type: "manual_select",
    multi: false,
    presetKey:"id_manual_select"
  },
  duration_manual_feat_select: {
    prompt:"Please manually select the time column(s) (multiple choice):",
    type: "manual_select",
    multi: true,
    presetKey:"duration_manual_feat_select",
  },
  survival_manual_feat_select: {
    prompt:"Please manually select the survival status column (single choice):",
    type: "manual_select",
    multi: true,
    presetKey:"survival_manual_feat_select",
  },
  id_manual_feat_select: {
    prompt:"Please manually select the ID column (single choice):",
    type: "manual_select",
    multi: false,
    presetKey:"id_manual_feat_select"
  },
}




 